import React from "react";

export function XIcon({ className }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2462_5464)">
        <path
          d="M13.8595 10.4643L21.1412 2H19.4157L13.093 9.34942L8.04317 2H2.21875L9.85513 13.1136L2.21875 21.9897H3.94436L10.6212 14.2285L15.9542 21.9897H21.7787L13.8591 10.4643H13.8595ZM11.4961 13.2115L10.7224 12.1049L4.56612 3.29901H7.21655L12.1847 10.4056L12.9584 11.5123L19.4165 20.7498H16.766L11.4961 13.212V13.2115Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
